import { configureStore } from "@reduxjs/toolkit";
import AuthReducer from "./auth/AuthReducer";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import persistStore from "redux-persist/es/persistStore";
import DocumentsReducer from "./documents/DocumentReducer";
import QdsDocumentsReducer from "./qdsDocuments/QdsDocumentReducer";
import CounterReducer from "./counters/CounterReducer";
import FilterReducer from "./filters/FilterReducer";
import OrganizationReducer from "./organizations/OrganizationReducer";

// store
export const store = configureStore({
  reducer: {
    auth: AuthReducer,
    organizations: OrganizationReducer,
    documents: DocumentsReducer,
    qdsDocuments: QdsDocumentsReducer,
    counter: CounterReducer,
    filter: FilterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
});

// store state
export type RootState = ReturnType<typeof store.getState>;

// dispatch
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;

// selector
export type AppSelector<S> = (state: RootState) => S;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

//persistor
export const persistor = persistStore(store);
